import React from 'react';

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner-container__content" />
  </div>
);

export default Spinner;
